import { render, staticRenderFns } from "./CustomerMenu.vue?vue&type=template&id=5f615d25&scoped=true"
import script from "./CustomerMenu.vue?vue&type=script&lang=js"
export * from "./CustomerMenu.vue?vue&type=script&lang=js"
import style0 from "./CustomerMenu.vue?vue&type=style&index=0&id=5f615d25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f615d25",
  null
  
)

export default component.exports